<form [formGroup]="form" fxLayout="row wrap" class="group-advanced-cntr">
  
    <h4 style="margin-top: 0;">Approvazione preventivi:</h4>

    
  <div fxFlex.gt-sm="100" fxFlex.gt-md="100" fxFlex="100" style="margin-bottom: 25px;">
    <section>
      <mat-checkbox class="checkbox-margin" formControlName="AutoAcceptPrintQuote">
        Accettazione automatica preventivi
      </mat-checkbox>
    </section>
  </div>

    <div fxFlex.gt-sm="100" fxFlex.gt-md="100" fxFlex="100">
      <mat-form-field>
        <mat-label>N° approvazioni per accettare preventivi</mat-label>
        <input matInput placeholder="N° approvazioni" formControlName="QuoteApprovalsCount" />
      </mat-form-field>
    </div>
  
  </form>
  